/* eslint-disable @typescript-eslint/explicit-function-return-type */
import { ModuleManifest } from "shared/bootstrap";
import publicLocale from "./i18n/public.json";

const manifest: ModuleManifest = {
  menuItems: [
    {
      to: { name: "my-appointments" },
      title: "appointments.menuItems.myAppointments",
      icon: "calendar",
      hideNoAuth: true,
    },
  ],
  routes: [
    {
      path: "/mijn-afspraken",
      name: "my-appointments",
      meta: {
        auth: true,
        title: "appointments.menuItems.myAppointments",
      },
      component: () => import("./pages/MyAppointments.vue"),
    },
  ],
  localisation: { key: "appointments", messages: publicLocale },
};

export default manifest;
